<template>
  <main :class="containerClass">
    <img class="img_glow_left" src="/static/images/home/glow.png"/>

    <slot name="default"></slot>
  </main>
</template>

<script>
export default {
  name: 'AuthPageWrapper',
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/wrapper/AuthPageWrapper.vue